module.exports = __webpack_public_path__ + "static/media/AmericanEquity.1df00980.webp";